import React from 'react';
import PropTypes from 'prop-types';
import DataComponentTable from './DataComponent__Table';
import DataComponentTile from './DataComponent__Tile';

const DataComponentBody = ({
    data,
    headerNames,
    multiLevelHeaderNames,
    columnData,
    loading,
    settings,
    settingKey,
    filters,
    className,
    displayControl,
    headerNamesArray
}) => {
    const getRenderComponent = () => {
        const data = displayControl.data.find(item => item.type === displayControl.type);
        const Component = data.component;

        if (React.isValidElement(Component)) {
            return Component;
        } else {
            return (
                <Component
                    data={data}
                />
            );
        }
    };

    const renderTable = () => {
        return (
            <DataComponentTable
                data={data}
                headerNames={headerNames}
                multiLevelHeaderNames={multiLevelHeaderNames}
                columnData={columnData}
                loading={loading}
                settings={settings}
                settingKey={settingKey}
                filters={filters}
                className={className}
            />
        );
    };

    const renderTile = () => {
        return (
            <DataComponentTile
                data={data}
                headerNames={headerNames}
                headerNamesArray={headerNamesArray}
                multiLevelHeaderNames={multiLevelHeaderNames}
                columnData={columnData}
                loading={loading}
                settings={settings}
                settingKey={settingKey}
                filters={filters}
                className={className}
            />
        );
    };

    return (
        displayControl
            ? !displayControl.type || displayControl.type === 'table'
                ? renderTable()
                : displayControl.type === 'tile' ? renderTile() : getRenderComponent()
            : renderTable()
    );
};

DataComponentBody.propTypes = {
    data: PropTypes.array,
    headerNames: PropTypes.object,
    multiLevelHeaderNames: PropTypes.object,
    columnData: PropTypes.object,
    loading: PropTypes.bool,
    settings: PropTypes.bool,
    settingKey: PropTypes.string,
    filters: PropTypes.object,
    className: PropTypes.string,
    displayControl: PropTypes.object,
    headerNamesArray: PropTypes.bool
};

DataComponentBody.defaultProps = {
    data: [],
    headerNames: {},
    multiLevelHeaderNames: {},
    columnData: {},
    loading: false,
    settings: false,
    settingKey: '',
    filters: {},
    className: '',
    displayControl: null,
    headerNamesArray: false
};

export default DataComponentBody;
